import * as React from 'react';

import type { PreviewVM } from 'ab-viewModels/account/preview.viewModel';

import Pill from 'af-components/Pills/Pill';
import Tooltip from 'af-components/Tooltip';

const renderPillItem = (item: PreviewVM) => {
	return (
		<div>
			{item.fullName} ({item.uniqueId})
		</div>
	);
};

interface OwnProps {
	removeAccount: (index: number) => void;
	index: number;
	account: PreviewVM;
	willReceiveNotification: boolean;
	hasEmail: boolean;
	isDeactivated?: boolean;
	isDisabled?: boolean;
}

type Props = OwnProps;

const AccountPreview: React.FC<Props> = (props) => {
	const { account, willReceiveNotification, hasEmail, removeAccount, index, isDeactivated, isDisabled = false } = props;

	const onRemoveAccount = React.useCallback(() => {
		removeAccount(index);
	}, [index, removeAccount]);

	let tooltipMessage = '';
	if (!hasEmail) {
		tooltipMessage = `${account.fullName} won't be notified (missing ${!hasEmail ? 'email' : 'mobile phone'})`;
	}

	if (!!isDeactivated) {
		tooltipMessage = `${account.fullName} won't be notified (DEACTIVATED)`;
	}

	const body = (
		<Pill
			isLocked={!!isDisabled}
			isTransparent={!willReceiveNotification}
			item={account}
			removeItem={onRemoveAccount}
			renderItem={renderPillItem}
			skipConfirmationModal={true}
		/>
	);

	if (willReceiveNotification) {
		return body;
	}

	return (
		<Tooltip
			className="tooltip--center-text"
			message={tooltipMessage}
			placement="top"
		>
			<div>{body}</div>
		</Tooltip>
	);
};

export default React.memo(AccountPreview);
